/**
 * ACT-13: the support-session token lives in sessionStorage of the support TAB only (the admin
 * console opens the workspace URL with `#support=<token>`; the fragment never reaches a server).
 * It is sent as `X-Support-Session`; the API enforces expiry, scope and the forbidden actions.
 */
const KEY = "wato_support_token";
export const SUPPORT_HEADER = "x-support-session";

function store(): Storage | null {
  try {
    return typeof sessionStorage === "undefined" ? null : sessionStorage;
  } catch {
    return null;
  }
}

export function getSupportToken(): string | null {
  try {
    const m = /(?:^|[#&])support=(wato_ss_[A-Za-z0-9_-]+)/.exec(globalThis.location?.hash ?? "");
    if (m?.[1]) {
      store()?.setItem(KEY, m[1]);
      globalThis.history?.replaceState(
        null,
        "",
        globalThis.location.pathname + globalThis.location.search,
      );
    }
    return store()?.getItem(KEY) ?? null;
  } catch {
    return null;
  }
}

export function clearSupportToken(): void {
  try {
    store()?.removeItem(KEY);
  } catch {
    /* storage unavailable: nothing to clear */
  }
}
